
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M446.3 19.3l-424 368.2C-25.4 429 8.4 500 76 500h848c67.6 0 101.5-71 53.7-112.5l-424-368.2C524-6.4 476-6.4 446.3 19.3z"}})])
          )
        }
      }
    